import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Col, CardBody, Container, Button } from "reactstrap";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { withStyles } from "@material-ui/core/styles";
import FormHelperText from "@material-ui/core/FormHelperText";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import ModalMessage from "../../../shared/components/Modal";
import Modal from "@material-ui/core/Modal";
import history from "../../../history";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const styles = (theme) => ({
  date: {
    margin: 10,
    width: 215,
  },
});

class UpdateUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typeOfDocument: "",
      documentNumber: "",
      id_user: "",
      username: "",
      names: "",
      firstLastName: "",
      secondLastName: "",
      estado: "",
      address: "",
      email: "",
      gender: "",
      cellphone: "",
      telephone1: "",
      telephone2: "",
      id_perfil: "",
      birthday: new Date(),
      id_cargo: "",
      id_usuario: "",
      intentos: "",
      password: "",
      races: [],
      ethnicity: "",
      ethnicities: [],
      country: "",
      department: "",
      city: "",
      id_city: "",
      regime: "",
      regimes: [],
      exist: false,
      update: false,
      errors: {},
      error: false,
      openAlert: false,
      modalAlert: { message: "", color: "", title: "" },
      openMap: false,
      loading: true,
      countries: [],
      departments: [],
      cities: [],
      charges: [],
      charge: null,
      id_gd_roles: null,
      rol: null,
      roles: [],
      id_gd_dependencia: null,
      dependencia: null,
      dependencias: [],
    };
  }

  handlerDocumentNumber = (number) => {
    this.setState({ documentNumber: number }, () => {});
  };

  handlerPassword = (password) => {
    this.setState({ password: password }, () => {});
  };

  handlerTypeOfDocument = (type) => {
    this.setState({ typeOfDocument: type });
  };

  handlerNames = (names) => {
    this.setState({ names: names });
  };

  handlerFirstLastName = (name) => {
    this.setState({ firstLastName: name });
  };

  handlerSecondLastName = (name) => {
    this.setState({ secondLastName: name });
  };

  handlerGender = (gender) => {
    this.setState({ gender: gender });
  };

  handlerBirthDate = (birthday) => {
    this.setState({ birthday: birthday });
  };

  handlerCivilStatus = (status) => {
    this.setState({ civilStatus: status });
  };

  handlerRace = (race) => {
    this.setState({ race: race });
  };

  handlerEthnicity = (ethnicity) => {
    this.setState({ ethnicity: ethnicity });
  };

  handlerCountry = (country) => {
    this.setState(
      { country: country, departments: [], city: [], cities: [] },
      () => {
        this.loadDepartment(country).then((departamentos) => {
          this.setState({ departments: departamentos });
        });
      }
    );
  };

  handlerDepartment = (department) => {
    this.setState({ department: department, city: [] }, () => {
      this.loadCities(department).then((cities) => {
        this.setState({ cities: cities });
      });
    });
  };

  handleCity = (city) => {
    this.setState({ city: city, id_city: city });
  };

  handlerAddress = (address) => {
    this.setState({ address: address });
  };

  handlerTelephone1 = (telephone) => {
    this.setState({ telephone1: telephone });
  };

  handlerTelephone2 = (telephone) => {
    this.setState({ telephone2: telephone });
  };

  handlerCellphone = (cellphone) => {
    this.setState({ cellphone: cellphone });
  };

  handlerEmail = (email) => {
    this.setState({ email: email });
  };

  handlerRegime = (regime) => {
    this.setState({ regime: regime });
  };

  handlerBloodType = (bloodType) => {
    this.setState({ bloodType: bloodType });
  };

  componentDidMount = () => {
    console.log(this.props);
    //this.setDataUser();
    this.loadUser(this.props);
    this.LoadRaces();
    this.LoadEthnicities();
    this.loadRegimes();
    this.loadDepartment().then((departments) => {
      this.setState({ departments: departments }, () => {
        this.loadCountries().then((countries) => {
          this.setState({ countries: countries });
        });
      });
    });
    this.loadCities();
    this.loadCharges();
    this.loadRoles();
    this.loadDependencias();
  };

  setDataUser = (user) => {
    //const user = this.props.location.state.user;

    this.setState({
      loading: false,
      documentNumber: user[0].num_documento,
      id_user: user[0].id_usuario,
      password: user[0].password,
      names: user[0].nombres,
      firstLastName: user[0].apellido1,
      secondLastName: user[0].apellido2,
      gender: user[0].sexo,
      address:
        typeof user[0].direccion.direccion == "undefined"
          ? ""
          : user[0].direccion.direccion,
      department:
        user[0].direccion === null ? "" : user[0].direccion.id_departamento,
      city: user[0].direccion === null ? "" : user[0].direccion.ciudad,
      id_city: user[0].direccion === null ? "" : user[0].direccion.id_ciudad,
      country: user[0].direccion === null ? "" : user[0].direccion.id_pais,
      email: user[0].correo,
      cellphone: user[0].celular,
      telephone1: user[0].tel_fijo,
      telephone2: user[0].telefono2,
      birthday: user[0].fec_nacimiento,
      typeOfDocument: user[0].tip_documento,
      id_usuario: user[0].id_usuario,
      id_cargo: user[0].id_cargo,
      id_perfil: user[0].id_perfil,
      charge: user[0].nombre_cargo,
      id_gd_roles: user[0].id_gd_roles,
      rol: user[0].nombre_rol,
      id_gd_dependencia: user[0].id_gd_dependencia,
      dependencia: user[0].nombre_dependencia
    });
  };

  loadCharges = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "cargo/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ charges: data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadRoles = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "rol/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ roles: data.results });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadDependencias = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "dependencia/listar?estado=A", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ dependencias: data.results });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadUser = async (props) => {
    console.log(props.location.state.user);

    //this.setState({ planName: this.state.plans.filter((plan) => plan.id_plan === this.state.idPlan)[0].nombre })

    let data = { num_documento: props.location.state.user.num };

    await fetch(process.env.REACT_APP_PUBLIC_URL + "usuario/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("datos del usuario", data);

        if (data.existe) {
          const user = data.contenido.filter(
            (usr) => usr.id_usuario === this.props.location.state.user.id
          );

          this.setDataUser(user);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadClientAndActivity = () => {
    fetch(process.env.REACT_APP_PUBLIC_URL + "serter/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        //console.log(data);
        this.setState({ serter: data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadPlans = (tercero) => {
    var data = { id: tercero.id_tercero };
    fetch(process.env.REACT_APP_PUBLIC_URL + "plan/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.existe) {
          this.setState({
            plans: data.contenido,
            activities: [],
            activity: {},
          });
        } else {
          this.setState({ plans: [], plan: {}, activities: [], activity: {} });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadActivities = (tercero, plan) => {
    var data = { id_tercero: tercero.id_tercero, id_plan: plan.id_plan };
    fetch(process.env.REACT_APP_PUBLIC_URL + "serter/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.existe) {
          this.setState({ activities: data.contenido[0].servicios.servicios });
        } else {
          this.setState({ activities: [], activity: {} });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  LoadEthnicities = () => {
    fetch(process.env.REACT_APP_PUBLIC_URL + "etnia/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        //console.log(data);
        this.setState({ ethnicities: data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  LoadRaces = () => {
    fetch(process.env.REACT_APP_PUBLIC_URL + "raza/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        //console.log(data);
        this.setState({ races: data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadRegimes = () => {
    fetch(process.env.REACT_APP_PUBLIC_URL + "regimen/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        //console.log(data);
        this.setState({ regimes: data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadCountries = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "paises/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  loadDepartment = (paicod) => {
    return new Promise((resolve, reject) => {
      const getURL = paicod
        ? `departamentos/listar?id_pais=${paicod}`
        : `departamentos/listar`;
      fetch(process.env.REACT_APP_PUBLIC_URL + getURL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  loadCities = (depcod) => {
    var data = { id_dpto: depcod };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "ciudades/listar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  loadcity = (id) => {
    let data = { id_ciudad: id };
    //console.log(data);
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "ciudades/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data);
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  validateData = () => {
    var errors = this.state.errors;
    var error = false;

    if (this.state.typeOfDocument === "") {
      errors.typeOfDocument = "Seleccione un tipo de documento";
      error = true;
    } else {
      errors.typeOfDocument = "";
    }

    if (this.state.documentNumber === "") {
      errors.documentNumber = "Ingrese un número de documento";
      error = true;
    } else {
      errors.documentNumber = "";
    }

    if (this.state.names === "") {
      errors.names = "Ingrese al menos un nombre";
      error = true;
    } else {
      errors.names = "";
    }

    if (this.state.firstLastName === "") {
      errors.firstLastName = "Ingrese apellido";
      error = true;
    } else {
      errors.firstLastName = "";
    }

    if (this.state.secondLastName === "") {
      errors.secondLastName = "Ingrese apellido";
      error = true;
    } else {
      errors.secondLastName = "";
    }

    if (this.state.gender === "") {
      errors.gender = "Seleccione un genero";
      error = true;
    } else {
      errors.gender = "";
    }

    if (
      moment(this.state.birthday).format("YYYY/MM/DD") ===
      moment(new Date()).format("YYYY/MM/DD")
    ) {
      errors.birthday = "Seleccione una fecha";
      error = true;
    } else {
      errors.birthday = "";
    }

    if (this.state.country === "") {
      errors.country = "Seleccione un país";
      error = true;
    } else {
      errors.country = "";
    }

    if (this.state.department === "") {
      errors.department = "Seleccione un departamento";
      error = true;
    } else {
      errors.department = "";
    }

    if (this.state.city === "") {
      errors.city = "Seleccione una ciudad";
      error = true;
    } else {
      errors.department = "";
    }

    if (this.state.address === "") {
      errors.address = "Ingrese una dirección";
      error = true;
    } else {
      errors.address = "";
    }

    if (this.state.telephone1 === "") {
      errors.telephone1 = "Ingrese una telefono";
      error = true;
    } else {
      errors.telephone1 = "";
    }

    if (this.state.cellphone === "") {
      errors.cellphone = "Ingrese un celular";
      error = true;
    } else {
      errors.cellphone = "";
    }

    if (this.state.email === "") {
      errors.email = "Ingrese un email";
      error = true;
    } else {
      errors.email = "";
    }

    if (this.state.civilStatus === "") {
      errors.civilStatus = "Seleccione un estado civil";
      error = true;
    } else {
      errors.civilStatus = "";
    }

    if (this.state.race === "") {
      errors.race = "Seleccione un raza";
      error = true;
    } else {
      errors.race = "";
    }

    if (this.state.ethnicity === "") {
      errors.ethnicity = "Seleccione etnia";
      error = true;
    } else {
      errors.ethnicity = "";
    }

    if (this.state.bloodType === "") {
      errors.bloodType = "Seleccione etnia";
      error = true;
    } else {
      errors.bloodType = "";
    }

    this.setState({ errors: errors, error: error });
  };

  updateUser = () => {
    this.validateData();
    if (this.state.error) {
      let data = {
        ape1: this.state.firstLastName,
        ape2: this.state.secondLastName,
        nombres: this.state.names,
        sexo: this.state.gender,
        fec_nacimiento: this.state.birthday,
        direccion: {
          id_pais: this.state.paicod,
          id_dpto: this.state.departments.filter(
            (department) => department.depcod === this.state.department
          )[0].depcod,
          id_ciudad: this.state.id_city,
          direccion: this.state.address,
        },
        tel_fijo: this.state.telephone1,
        telefono2: this.state.telephone2,
        celular: this.state.cellphone,
        correo: this.state.email,
        id_cargo: this.state.id_cargo,
        id_usuario: this.state.id_usuario,
        id_perfil: this.state.id_perfil,
        id_gd_roles: this.state.id_gd_roles,
        id_gd_dependencia: this.state.id_gd_dependencia
      };

      fetch(process.env.REACT_APP_PUBLIC_URL + "usuario/update", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          }
        })
        .then((data) => {
          console.log("usuarioooo actualizado",data);
          this.setState({
            openAlert: true,
            modalAlert: {
              message: "Usuario actualizado con exito",
              color: "success",
              title: "Exitoso!",
            },
          });
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Container className="dashboard">
        <Col>
          <Col md={12}>
            <h3 style={{ marginBottom: 30 }}>Actualizar Usuario</h3>
            <Button
              style={{ marginBottom: 20 }}
              color="primary"
              size="sm"
              onClick={() => {
                history.push({
                  pathname: process.env.PUBLIC_URL + "/config/manage-users",
                });
              }}
            >
              <ArrowBackIcon />
            </Button>
          </Col>

          <CardBody>
            <div style={{ marginLeft: 10, marginTop: 10 }}>
              <h5>Datos básicos</h5>
            </div>
            <div style={{ flex: 1, flexDirection: "row" }}>
              <div style={{ flex: 1, flexDirection: "row" }}>
                <TextField
                  required
                  className={classes.date}
                  id="first-name-standard-required"
                  label="Nombres"
                  type="text"
                  value={this.state.names}
                  onChange={(e) => {
                    this.handlerNames(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("names")
                      ? this.state.errors.names !== ""
                      : false
                  }
                  helperText={this.state.errors.names}
                />
                <TextField
                  required
                  className={classes.date}
                  id="first-last-name-standard-required"
                  label="Primer apellido"
                  type="text"
                  value={this.state.firstLastName}
                  onChange={(e) => {
                    this.handlerFirstLastName(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("firstLastName")
                      ? this.state.errors.firstLastName !== ""
                      : false
                  }
                  helperText={this.state.errors.firstLastName}
                />
                <TextField
                  required
                  className={classes.date}
                  id="second-last-name-standard-required"
                  label="Segundo apellido"
                  type="text"
                  value={this.state.secondLastName}
                  onChange={(e) => {
                    this.handlerSecondLastName(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("secondLastName")
                      ? this.state.errors.secondLastName !== ""
                      : false
                  }
                  helperText={this.state.errors.secondLastName}
                />
                <FormControl
                  className={classes.date}
                  error={
                    this.state.errors.hasOwnProperty("gender")
                      ? this.state.errors.gender !== ""
                      : false
                  }
                >
                  <InputLabel required id="demo-simple-select-label">
                    Genero
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="id-simple-select"
                    defaultValue={null}
                    value={this.state.gender}
                    onChange={(event) => {
                      this.handlerGender(event.target.value);
                    }}
                    error={
                      this.state.errors.hasOwnProperty("gender")
                        ? this.state.errors.gender !== ""
                        : false
                    }
                    helperText={this.state.errors.gender}
                  >
                    <MenuItem key={0} value={""}>
                      Ninguno
                    </MenuItem>
                    <MenuItem key={1} value={"Masculino"}>
                      Masculino
                    </MenuItem>
                    <MenuItem key={2} value={"Femenino"}>
                      Femenino
                    </MenuItem>
                    <MenuItem key={3} value={"Binario"}>
                      Binario
                    </MenuItem>
                  </Select>
                  <FormHelperText>{this.state.errors.gender}</FormHelperText>
                </FormControl>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <DatePicker
                    disableFuture
                    openTo="year"
                    label="Fecha de Nacimiento"
                    views={["year", "month", "date"]}
                    value={this.state.birthday}
                    onChange={(date) => {
                      this.handlerBirthDate(new Date(date));
                    }}
                    animateYearScrolling
                    format="yyyy/MM/D"
                    className={classes.date}
                    error={
                      this.state.errors.hasOwnProperty("birthday")
                        ? this.state.errors.birthday !== ""
                        : false
                    }
                    helperText={this.state.errors.birthday}
                  />
                </MuiPickersUtilsProvider>

                <TextField
                  required
                  className={classes.date}
                  id="first-telephone-standard-required"
                  label="Teléfono 1"
                  type="text"
                  value={this.state.telephone1}
                  onChange={(e) => {
                    this.handlerTelephone1(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("telephone1")
                      ? this.state.errors.telephone1 !== ""
                      : false
                  }
                  helperText={this.state.errors.telephone1}
                />
                <TextField
                  className={classes.date}
                  id="second-telephone-standard-required"
                  label="Teléfono 2"
                  type="text"
                  value={this.state.telephone2}
                  onChange={(e) => {
                    this.handlerTelephone2(e.target.value);
                  }}
                />
                <TextField
                  required
                  className={classes.date}
                  id="cellphone-standard-required"
                  label="Celular"
                  type="text"
                  value={this.state.cellphone}
                  onChange={(e) => {
                    this.handlerCellphone(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("cellphone")
                      ? this.state.errors.cellphone !== ""
                      : false
                  }
                  helperText={this.state.errors.cellphone}
                />
                <TextField
                  required
                  className={classes.date}
                  id="email-standard-required"
                  label="Correo electrónico"
                  type="email"
                  value={this.state.email}
                  onChange={(e) => {
                    this.handlerEmail(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("email")
                      ? this.state.errors.email !== ""
                      : false
                  }
                  helperText={this.state.errors.email}
                />
                <FormControl className={classes.date}>
                  <InputLabel id="charge-status-select-label">Cargo</InputLabel>
                  <Select
                    labelId="charge-select-label"
                    id="id-simple-select"
                    defaultValue={null}
                    value={this.state.id_cargo}
                    onChange={(event) => {
                      this.setState({ id_cargo: event.target.value });
                    }}
                  >
                    {this.state.charges.map((charge) => {
                      return (
                        <MenuItem key={charge.id_cargo} value={charge.id_cargo}>
                          {charge.cargo}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <FormControl className={classes.date}>
                  <InputLabel id="charge-status-select-label" shrink={true}>
                    Rol
                  </InputLabel>
                  <Select
                    labelId="role-select-label"
                    id="id-simple-select"
                    defaultValue={null}
                    value={this.state.id_gd_roles}
                    onChange={(event) => {
                      this.setState({ id_gd_roles: event.target.value });
                    }}
                  >
                    {this.state.roles.map((rol) => {
                      return (
                        <MenuItem key={rol.id_gd_roles} value={rol.id_gd_roles}>
                          {rol.nombre}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <FormControl className={classes.date}>
                  <InputLabel id="dependence-status-select-label" shrink={true}>
                    Dependencia
                  </InputLabel>
                  <Select
                    labelId="dependence-select-label"
                    id="id-simple-select"
                    defaultValue={null}
                    value={this.state.id_gd_dependencia}
                    onChange={(event) => {
                      this.setState({ id_gd_dependencia: event.target.value });
                    }}
                  >
                    {this.state.dependencias.map((dep) => {
                      return (
                        <MenuItem
                          key={dep.id_gd_dependencia}
                          value={dep.id_gd_dependencia}
                        >
                          {dep.descripcion}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>

                <div style={{ marginLeft: 10, marginTop: 10 }}>
                  <h5>Datos Ubicación</h5>
                </div>
                <div>
                  <FormControl
                    className={classes.date}
                    error={
                      this.state.errors.hasOwnProperty("country")
                        ? this.state.errors.country !== ""
                        : false
                    }
                  >
                    <InputLabel id="country-status-select-label">
                      País
                    </InputLabel>
                    <Select
                      labelId="country-select-label"
                      id="id-simple-select"
                      defaultValue={null}
                      value={this.state.country}
                      onChange={(event) => {
                        this.handlerCountry(event.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("country")
                          ? this.state.errors.country !== ""
                          : false
                      }
                    >
                      {this.state.countries.map((country) => {
                        return (
                          <MenuItem key={country.id} value={country.id}>
                            {country.painom}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    <FormHelperText>{this.state.errors.country}</FormHelperText>
                  </FormControl>
                  <FormControl
                    className={classes.date}
                    error={
                      this.state.errors.hasOwnProperty("department")
                        ? this.state.errors.department !== ""
                        : false
                    }
                  >
                    <InputLabel id="department-status-select-label">
                      Departamento
                    </InputLabel>
                    <Select
                      labelId="department-select-label"
                      id="id-simple-select"
                      defaultValue={null}
                      value={this.state.department}
                      onChange={(event) => {
                        this.handlerDepartment(event.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("department")
                          ? this.state.errors.department !== ""
                          : false
                      }
                    >
                      {this.state.departments.length ? (
                        this.state.departments.map((department) => {
                          return (
                            <MenuItem
                              key={department.id}
                              value={department.depcod}
                            >
                              {department.depnom}
                            </MenuItem>
                          );
                        })
                      ) : (
                        <MenuItem value="">No hay departamentos</MenuItem>
                      )}
                    </Select>
                    <FormHelperText>
                      {this.state.errors.department}
                    </FormHelperText>
                  </FormControl>
                  <FormControl
                    className={classes.date}
                    error={
                      this.state.errors.hasOwnProperty("city")
                        ? this.state.errors.city !== ""
                        : false
                    }
                  >
                    <InputLabel id="city-status-select-label">
                      Ciudad
                    </InputLabel>
                    <Select
                      labelId="city-select-label"
                      id="id-simple-select"
                      defaultValue={null}
                      value={this.state.city}
                      onChange={(event) => {
                        this.handleCity(event.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("city")
                          ? this.state.errors.city !== ""
                          : false
                      }
                    >
                      <MenuItem key={0} value={this.state.city}>
                        {this.state.city}
                      </MenuItem>
                      {this.state.cities.length ? (
                        this.state.cities.map((city) => {
                          return (
                            <MenuItem key={city.id} value={city.ciucod}>
                              {city.ciunom}
                            </MenuItem>
                          );
                        })
                      ) : (
                        <MenuItem value="">No hay ciudades</MenuItem>
                      )}
                    </Select>
                    <FormHelperText>{this.state.errors.city}</FormHelperText>
                  </FormControl>
                  <TextField
                    required
                    className={classes.date}
                    id="address-standard-required"
                    label="Dirección"
                    type="text"
                    value={this.state.address}
                    onChange={(e) => {
                      this.handlerAddress(e.target.value);
                    }}
                    error={
                      this.state.errors.hasOwnProperty("address")
                        ? this.state.errors.address !== ""
                        : false
                    }
                    helperText={this.state.errors.address}
                  />
                </div>
              </div>
              <Button
                className={classes.date}
                style={{ marginTop: 20 }}
                variant="contained"
                color="primary"
                onClick={() => {
                  this.updateUser();
                }}
              >
                Actualizar Usuario
              </Button>
            </div>
            {this.state.openAlert ? (
              <ModalMessage
                color={this.state.modalAlert.color}
                title={this.state.modalAlert.title}
                message={this.state.modalAlert.message}
                modal={this.state.openAlert}
                toggle={() => {
                  this.setState({ openAlert: !this.state.openAlert });
                }}
                onOk={() => {
                  history.push({
                    pathname: process.env.PUBLIC_URL + "/config/manage-users",
                  });
                }}
              />
            ) : null}
            <Modal
              open={this.state.openMap}
              onClose={(e) => {
                this.setState({ openMap: !this.state.openMap });
              }}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              //style={{zIndex: 1000 }}
            ></Modal>
          </CardBody>
        </Col>
      </Container>
    );
  }
}

export default withStyles(styles, { withTheme: true })(UpdateUser);
